package ui.external.materialui

object FontSize {
    const val initial = "initial"
}
